export const disponentUserGroup = ['18', '19'];
export const premiumUserGroup = ['22'];
